/* eslint-disable quotes */
/* eslint-disable semi */
import { storeGetters } from  '../../getters.constants';

const getters = {
 
  [storeGetters.saveHtmlContent]: (state) => {
    return state.message;
  },
  [storeGetters.getHtmlContent]: (state) => {
    return state.htmlContent;
  },
};
export default { ...getters };
